import { render } from "./PaywallPromo.vue?vue&type=template&id=1494818a"
import script from "./PaywallPromo.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallPromo.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallPromo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1494818a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1494818a', __exports__)) {
    api.reload('1494818a', __exports__)
  }
  
  module.hot.accept("./PaywallPromo.vue?vue&type=template&id=1494818a", () => {
    api.rerender('1494818a', render)
  })

}


export default __exports__